var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"requestAWSForm"}},[(_vm.showRequestAwsQuestionnaire)?_c('formReqAwsQuestionnaire'):_vm._e(),(_vm.showRequestAwsContacts)?_c('formReqAwsContact'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }